import { useState, useRef, useCallback } from "react";
import { getLoggedInUserAdmissionNo } from "../../../modules/common/user/UserService";
import { getFees } from "../services/studentFeeService";
import { Fee } from "../types";

export const useStudentFee = () => {
  const [admissionNo] = useState<string>(getLoggedInUserAdmissionNo());
  const [fees, setFees] = useState<Fee[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fetched, setFetched] = useState(false);

  const fetchFees = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getFees(admissionNo);
      setFees(data);
    } catch (err) {
      setError("Failed to fetch fee dues.");
    } finally {
      setLoading(false);
      setFetched(true); // ← mark as fetched
    }
  }, [admissionNo]);

  return { fetchFees, fees, loading, error, fetched };
};
